//import 'babel-polyfill'
import Vue from 'vue'
import Router from 'vue-router'
import App from '@/components/App'
//import Home from '@/components/HelloWorld'
import Projects from '@/components/Projects'

import Portfolio from '@/components/Portfolio'
import Fund from '@/components/Fund'
import Project from '@/components/Project'

//import store from '../../store'

//import Privacy from '@/components/Privacy'
//import Refund from '@/components/Refund'


Vue.use(Router)

/*
const Logout = {
    created() {
        this.$store.dispatch('logout')
    }
}
*/

export default new Router({
  routes: [
    {
      path: '/',
      name: 'App',
      component: App
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects
    },
    {
      path: '/logout',
      name: 'Logout',
      /*
      redirect: to => {
console.log('DEBUG','logging out!', to)
          if (to.hash == "#logout") {
console.log('DEBUG','for REAL!')
            store.dispatch('logout')
            return {path:'/'}
          }
          return null
      }
      */

    },
    {
      path: '/portfolio',
      name: 'Portfolio',
      component: Portfolio
    },
    {
      path: '/project',
      name: 'Project',
      component: Project
    },
    {
      path: '/fund',
      name: 'Fund',
      component: Fund 
    },
    /*
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy 
    },
    {
      path: '/refund',
      name: 'Refund',
      component: Refund 
    }
*/
  ]
})
